export const START_SIMULATOR = "START_SIMULATOR";
export const SUCCESS_SIMULATOR = "SUCCESS_SIMULATOR";
export const ERROR_SIMULATOR = "ERROR_SIMULATOR";

export const RESET_PATIENT_SIMULATOR = "RESET_PATIENT_SIMULATOR";
